import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';
import { UnsavedChangesGuard } from '../../shared/guards/unsaved-changes.guard';

export const proposalRoute: Route = {
  path: 'proposal',
  canActivate: [PermissionGuard],
  data: {
    permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER, Permission.CLIENT],
  },
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    {
      path: 'list',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER] },
      loadComponent: () => import('./list/list.component').then((c) => c.ProposalListComponent),
    },
    {
      path: 'create',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER] },
      loadComponent: () =>
        import('./create/create.component').then((c) => c.ProposalCreateComponent),
      canDeactivate: [UnsavedChangesGuard],
    },
    {
      path: 'mandate/:id',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER] },
      loadComponent: () =>
        import('./create/create.component').then((c) => c.ProposalCreateComponent),
      canDeactivate: [UnsavedChangesGuard],
    },
    {
      path: 'preview/:id',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER] },
      loadComponent: () =>
        import('./create/create.component').then((c) => c.ProposalCreateComponent),
      canDeactivate: [UnsavedChangesGuard],
    },
    {
      path: 'view/:id',
      canActivate: [PermissionGuard],
      data: {
        permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.CLIENT],
      },
      loadComponent: () => import('./view/view.component').then((c) => c.ProposalViewComponent),
    },
    {
      path: 'my',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.CLIENT] },
      loadComponent: () => import('./my/my.component').then((c) => c.MyProposalComponent),
    },
  ],
};
